/** @format */
import React from 'react';
import './styles.scss';

const CommonBanner = ({
  bannerClassName = 'btn-plain',
  animation = false,
  labelText
}) => (
  <div
    className={`object-status-indicator  ${bannerClassName} ${
      animation && 'animate'
    }`}>
    {labelText}
  </div>
);

export const BiddingBanner = (props) => {
  const { wrapperClassName = null, isMobile = false } = props || {};
  return (
    <div
      className={`object-status-indicator-wrapper ${
        wrapperClassName ? wrapperClassName : ''
      } ${isMobile ? 'mobile' : ''}`}>
      <CommonBanner
        {...props}
        bannerClassName='object-bidding-indicator in-progress'
      />
    </div>
  );
};

export const SoldBanner = (props) => {
  const { wrapperClassName = null, isMobile = false } = props || {};
  return (
    <div
      className={`object-status-indicator-wrapper ${
        wrapperClassName ? wrapperClassName : ''
      } ${isMobile ? 'mobile' : ''}`}>
      <CommonBanner {...props} bannerClassName='sold-indicator' />
    </div>
  );
};

export const ComingBanner = (props) => {
  const { wrapperClassName = null, isMobile = false } = props || {};
  return (
    <div
      className={`object-status-indicator-wrapper ${
        wrapperClassName ? wrapperClassName : ''
      } ${isMobile ? 'mobile' : ''}`}>
      <CommonBanner {...props} bannerClassName='coming-indicator' />
    </div>
  );
};
